import React from 'react';
import {YogaCounter} from './features/yoga/YogaForm'
import './App.css';
import {BackgroundPlayer} from "./features/player/BackgroundPlayer";
import {StatePlayer} from "./features/player/StatePlayer";

function App() {
    return (
        <div className="App">
            <header className="App-header">
                <YogaCounter/>
                <BackgroundPlayer/>
                <StatePlayer/>
            </header>
        </div>
    );
}

export default App;
